// extracted by mini-css-extract-plugin
module.exports = {"paragraphWithHeader":"paragraphWithHeader-module--paragraphWithHeader--1K7K4","appButton":"paragraphWithHeader-module--appButton--3-zVn"};